import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const navigation = [{
    name: 'Home',
    id: 'home'
  }, {
    name: 'Leistungen',
    id: 'services'
  }, {
    name: 'Prozess',
    id: 'process'
  }, {
    name: 'Branchen',
    id: 'industries'
  }, {
    name: 'ESG & Impact',
    id: 'esg'
  }, {
    name: 'Über FJT',
    id: 'about'
  }, {
    name: 'Kontakt',
    id: 'contact'
  }];
  useEffect(() => {
    const handleScroll = () => {
      const sections = navigation.map(nav => document.getElementById(nav.id));
      const scrollPosition = window.scrollY + 100;
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(navigation[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };
  return <header className="w-full bg-[#0A122A] backdrop-blur-sm border-b border-gray-800 sticky top-0 z-50 shadow-sm" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="flex justify-between items-center h-20" data-id="element-39">
          <button onClick={() => scrollToSection('home')} className="flex items-center cursor-pointer" data-id="element-40">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xdr61HSpUjGGYUGaLtPvn6/ForesightJounresTech_Logo_whtie.png" alt="Foresight Journey Technologies" className="h-16" data-id="element-41" />
          </button>
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-42">
            {navigation.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className={`text-sm font-medium transition-colors ${activeSection === item.id ? 'text-[#0B5FFF]' : 'text-gray-300 hover:text-white'}`} data-id="element-43">
                {item.name}
              </button>)}
            <button onClick={() => scrollToSection('contact')} className="px-6 py-2.5 bg-[#0B5FFF] text-white rounded-lg font-medium hover:bg-[#0952d9] transition-colors" data-id="element-44">
              Jetzt Projekt anstoßen
            </button>
          </nav>
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="lg:hidden p-2 text-white" data-id="element-45">
            {isMenuOpen ? <XIcon size={24} data-id="element-46" /> : <MenuIcon size={24} data-id="element-47" />}
          </button>
        </div>
        {isMenuOpen && <div className="lg:hidden py-4 border-t border-gray-800" data-id="element-48">
            <nav className="flex flex-col space-y-4" data-id="element-49">
              {navigation.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className={`text-base font-medium text-left ${activeSection === item.id ? 'text-[#0B5FFF]' : 'text-gray-300'}`} data-id="element-50">
                  {item.name}
                </button>)}
            </nav>
          </div>}
      </div>
    </header>;
}